/** @jsxImportSource @emotion/react */
import { memo } from "react";

// CSS読み込み
import {
  externakLinkWrap,
  externakLinkText,
  externakLinkImg,
} from "assets/css/stylesCss";

import small from "assets/img/link/ico-externallink-body-active.png";
import medium from "assets/img/link/ico-externallink-body-active@2x.png";
import large from "assets/img/link/ico-externallink-body-active@3x.png";

/**
 * 外部遷移アイコン付きリンク
 * @param {Object} customCss CSS変更用オブジェクト
 * @prop {String} url ジャンプ先URL
 * childrenには要素内の文字列が自動的に入る
 */
const ExternalLink = memo(({ customCss, url, children = false }) => {
  return (
    <div css={externakLinkWrap}>
      <a
        css={[externakLinkText, customCss]}
        href={url}
        rel="noreferrer"
        target="_blank"
      >
        {children}
        <img
          css={externakLinkImg}
          src={small}
          srcSet={`${small} 1x, ${medium} 2x, ${large} 3x`}
          alt="外部リンク"
        />
      </a>
    </div>
  );
});

export default ExternalLink;
